import { BaseFormat } from "./baseFormat";

export class TirinhaFormat extends BaseFormat {
  get tipo() {
    return "tirinha";
  }

  // Tirinha: 4 fotos empilhadas verticalmente numa folha 10x15
  get canvasSize() {
    return { width: 431, height: 160 };
  }

  get scaleFinal() {
    return 2;
  }

  get canvasCount() {
    return 4;
  }

  fitImageToCanvas(img, canvasSize) {
    img.scaleToWidth(canvasSize.width);
    img.center();
  }
}
